//This needs to be reviewed or check if we can use any other approach
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('imageurlThumbnailUpdate', {
    mounted(el, binding) {
      const onErrorHandler = () => {
        if (binding.value) {
          binding.value.imageUrl = '';
        }
      };

      el.__onError__ = onErrorHandler;
      el.addEventListener('error', onErrorHandler);
    }
    // The `update` and `unbind` methods can be implemented if needed
  });
});
